export enum EnumActionsInforme {
    VER = 1,
    EDITAR = 2,
    BORRAR = 3,
    RESTAURAR = 4,
    REPEDIR = 5
}
